/**
 * Shared color utilities for query type visualization
 * Provides consistent colors across administrative and account interfaces
 */

export const defaultQueryTypeColors: Record<string, string> = {
  fast: "var(--color-neon-green)",
  slow: "var(--color-violet-pulse)",
  visit: "var(--color-signal-blue)",
};

export const fallbackQueryTypeColors = [
  "hsl(280, 100%, 65%)",
  "hsl(200, 100%, 60%)",
  "hsl(30, 100%, 60%)",
  "hsl(160, 100%, 60%)",
  "hsl(340, 100%, 65%)",
];

/**
 * Get color for a query type, using default colors for known types
 * and fallback colors for unknown types
 */
export function getQueryTypeColor(type: string, index: number = 0): string {
  if (type in defaultQueryTypeColors) {
    return defaultQueryTypeColors[type]!;
  }
  return fallbackQueryTypeColors[index % fallbackQueryTypeColors.length]!;
}

/**
 * Tailwind class names for query type colors (for use in className)
 */
export const queryTypeColorClasses: Record<string, string> = {
  fast: "text-neon-green",
  slow: "text-violet-pulse",
  visit: "text-signal-blue",
};

/**
 * Get Tailwind color class for a query type
 */
export function getQueryTypeColorClass(type: string): string {
  return queryTypeColorClasses[type] || "text-chromium-mist";
}
